<p><img src="/assets/chris-smith.jpg" alt="Chris Smith" /></p>
<h1><a routerLink="/" routerLinkActive="_link-active">Chris Smith</a></h1>
<p class="softwareEngineer">software engineer</p>
<p>contact: <a href="mailto:chris@smith.xyz" routerLinkActive="_link-active">chris@smith.xyz</a><br />
download: <a href="/assets/Christopher Smith Resume.pdf">resume</a></p>
<p>I am an experienced software engineer who has built a wide range of projects
from <a href="https://gitlab.com/chris13524/tacodns" routerLinkActive="_link-active">new DNS server</a> to
<a href="https://givingtools.com" routerLinkActive="_link-active">online giving for non-profits</a>.</p>
